module.exports = __webpack_public_path__ + "static/media/account.6875647d.svg";